/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Publish_BackInputs */

const vi_einvoice_publish_back = /** @type {(inputs: Einvoice_Publish_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lại`)
};

/**

* @param {Einvoice_Publish_BackInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publish_back = /** @type {((inputs?: Einvoice_Publish_BackInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Publish_BackInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publish_back(inputs)
});